import * as React from "react";
import {InjectedProps, withVariableLookup} from "components/form/VariableLookup/VariableLookup";
import AutoComplete, {AutoCompleteProps} from "components/AutoComplete/AutoComplete";

const AutoCompleteWithInputRef = (props: AutoCompleteProps & InjectedProps) => <AutoComplete {...props} />;
export const VariableLookupAutoComplete = withVariableLookup()(AutoCompleteWithInputRef);